import { ELocale } from "@/stores/interface/interface.types";

const locale: Record<ELocale, string> = {
  [ELocale.FR]: "Français",
  [ELocale.EN]: "Anglais",
};

const settingsLocale = {
  settings: {
    title: "Paramètres",
    language: "Langue",
    languageHelp: "Faites-nous savoir dans quelle langue vous êtes le plus à l'aise. Vous pouvez changer à tout moment",
    largeScreen: "Disposition large",
    largeScreenHelp: "Modifie la disposition pour utiliser toute la largeur disponible",
    locale,
    fontSize: "Taille de la police",
    fontSizeHelp: "Modifie la taille de la police et l'échelle globale de l'interface",
  },
};

export type SettingsLocale = typeof settingsLocale;
export default settingsLocale;
